import { useUserState } from "../../context/UserContext";
// import Layout from "../../components/Layout";
import Trash from "./admin/index";

const index = () => {
  const { userRole } = useUserState();

  return (
    <>
      {userRole?.role === "school_admin" ? (
        <Trash />
      ) : null}
    </>
  );
};

export default index;
